// @flow

import type { MetaType } from '../types/entities';

export const UPDATE_META = 'UPDATE_META';

export function updateMeta(obj: MetaType) {
  return { type: UPDATE_META, obj };
}



// WEBPACK FOOTER //
// ./src/actions/meta.js